// styles and images
import Delete from '../assets/delete.svg'

export default function DeleteSelected({setDeleteIsTriggered, setId, id}) {
    const handleClick = () => {
        setId(id)
        setDeleteIsTriggered(true)
    }

    return (
        <div className='edits'>
            <img src={Delete} className='edit' onClick={handleClick} alt='delete'/>
        </div>
    )
}
